module.exports = "/images/user_white.svg?783a35556c9635004f0ce27a381cdbfd";